module.exports = __webpack_public_path__ + "img/headBG.b7e153b8.png";